import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { LanguageAssistant } from "../type";

export const updateGameNameAssistant = async (
  languageName: string,
  assistantId: string,
) => {
  const fn = httpsCallable(functions, "updateGameNameTranslationAssistant");
  const { data: responseData } = await fn({
    language: languageName,
    assistantId,
  });

  return responseData as LanguageAssistant;
};
